export default __webpack_public_path__ + "static/Scientist_F_400x650px-9d0494f599a4c3b1c83e8b3122d62b96.png";